import React, { useRef, useState } from 'react';
import { useGetWardsQuery } from '../Cleaner/CleanerSlice';
import { useAddcomplainAdminMutation } from './complainAdminListSlice';

const AddcomplainAdmin = () => {
    const [addCompalinweb, setAddCompalinweb] = useState({ ward_id: "", user_name: "", user_number: "", prp_name: "", address: "", complain_text: "" });
    const [addcomplainAdmin, { isLoading }] = useAddcomplainAdminMutation()

    const {
        data: Wards
    } = useGetWardsQuery("getWards");    

    const refClose = useRef(null);

    const handleChange = (e) => setAddCompalinweb({ ...addCompalinweb, [e.target.name]: e.target.value });

    const handleClick = async (e) => {
        e.preventDefault();
        try {
            const xyz = await addcomplainAdmin({
                ward_id: addCompalinweb.ward_id,
                user_name: addCompalinweb.user_name,
                user_number: addCompalinweb.user_number,
                prp_name: addCompalinweb.prp_name,
                address: addCompalinweb.address,
                complain_text: addCompalinweb.complain_text
            }).unwrap()
            setAddCompalinweb({ ward_id: "", user_name: "", user_number: "", prp_name: "", address: "", complain_text: "" })
            refClose.current.click()
        }
        catch (e) {
            console.log(e, "Error");
            console.error(e)
        }
    }

    return (
        <>
            <button type="button" className="Add_button bg-left-navabr  text-light  btn btn-secondary" data-bs-toggle="offcanvas" data-bs-target="#depOffCanvas" aria-controls="depOffCanvas"><i className="fa fa-plus" aria-hidden="true"></i> Add Compalin Admin</button>

            <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="1" id="depOffCanvas" aria-labelledby="depOffCanvas">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Add Compalin Admin</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={refClose}></button>
                </div>
                <div className="offcanvas-body">
                    <div>
                        <form className="row g-3">
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="user_name"
                                    name="user_name"
                                    value={addCompalinweb.user_name}
                                    onChange={handleChange}
                                    placeholder="Name"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Number
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="user_number"
                                    name="user_number"
                                    value={addCompalinweb.user_number}
                                    onChange={handleChange}
                                    placeholder="Number"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Property Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="prp_name"
                                    name="prp_name"
                                    value={addCompalinweb.prp_name}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Address
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="address"
                                    name="address"
                                    value={addCompalinweb.address}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="name" className="form-label font-weight-bold">
                                    Complain
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="complain_text"
                                    name="complain_text"
                                    value={addCompalinweb.complain_text}
                                    onChange={handleChange}
                                    placeholder=""
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="number" className="form-label font-weight-bold">Ward</label>
                                <select
                                    className="form-select mb-5"
                                    aria-label="complain status"
                                    id="ward_id"
                                    name="ward_id"
                                    value={addCompalinweb?.ward_id}
                                    onChange={handleChange}
                                >
                                    <option selected>--</option>
                                    {Wards?.ids?.map(item => {
                                        return <option value={Wards?.entities[item]?.ward_id}>{Wards?.entities[item]?.ward_number}</option>
                                    })}
                                </select>
                            </div>

                            <div className="col-md-12">
                                <button type="submit" className="btn btn-ff9b44 btn-block btn-round"
                                    onClick={handleClick}
                                    disabled={!(addCompalinweb.user_name)}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddcomplainAdmin;
